import React from 'react';

const PasswordInput = ({ value, onChange, inputStyles }) => {
    return (
        <div>

            <div className="mt-2">
                <input
                    value={value}
                    onChange={onChange}
                    id="password"
                    style={inputStyles}
                    placeholder="Please enter your password"
                    name="password"
                    type="password"
                    autoComplete={false}
                    required
                    className="keyboard block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
            </div>
        </div>
    );
};

export default PasswordInput;
